import { postMethodWithUpload } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPLOAD_PROFILE = 'UPLOAD_PROFILE';
export const UPLOAD_PROFILE_SUCCESS = 'UPLOAD_PROFILE_SUCCESS';
export const UPLOAD_PROFILE_FAILURE = 'UPLOAD_PROFILE_FAILURE';

// Action Creators
export const getUploadRequest = () => ({
  type: UPLOAD_PROFILE,
});

export const getUploadSuccess = (users) => ({
  type: UPLOAD_PROFILE_SUCCESS,
  payload: users,
});

export const getUploadFailure = (error) => ({
  type: UPLOAD_PROFILE_FAILURE,
  payload: error,
});

// Thunk Function
export const uploadAction = (body, external) => {
  return async (dispatch) => {
    dispatch(getUploadRequest());
    try {
      const response = await postMethodWithUpload(url.fileUpload, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getUploadSuccess(response));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getUploadFailure(error?.message));
    }
  };
};
